import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";

const state = {
  module: undefined,
  // dashboard
  dashboardAnnouncements: [],
  dashboardMyTasks: [],
  dashboardUpcomingEvents: [],
  // modules
  notifications: [],
  permittedModules: null,
  myTimes: [],
  myTime: null,
  myTimeOffBalance: [],
  myTimeOff: [],
  requestTrail: [],
  teamTime: [],
  employeesUnder: [],
  myPays: [],
  myPay: null,
  myTasks: [],
  myTasksCount: [],
  myTask: null,
  myProfile: null,
  myBenefits: [],
  myBenefit: null,
  myCareer: [],
  browseJobs: [],
  userManagement: [],
  roles: [],
  rolesAssociation: [],
  rolePermissions: [],
  timeOffRequestCreated: [],
  directDeposits: [],
  payrollItems: [],
  payrollItemDetails: [],
  payrollChecks: [],
  payrollCheckDetails: [],
  /**
   * @type {{code: string, description: string, id: number, status: string}[]}
   */
  payrollTask: [],
  /**
   * @type {{code: string, message: string}}
   */
  payrollRegistered: [],
  /**
   * @type {{id: number, value: string}[]}
   */
  nextStatusListTask: [],
  /**
   * @type {{id: number, assosOf: string, assos: string, assosWith: string, assosWithName: string}[]}
   */
  associationList: [],
  /**
   * @type {{code: string, description: string, id: number, status: string}[]}
   */
  costCenters: [],
  /**
   * @type {{code: string, description: string, id: number, status: string}[]}
   */
  userAssignments: [],
  timeEntryApprovalRefId: "",
  payCycles: [],
  payCycleDetail: [],
  taskPermission: [],
  userGroups: [],
  assignmentHistory: [],
  timeOffEntries: [],
  transactionDetails: [],
  publishedW2: [],
  attributes: [],
  dependents: [],
  requests: []
};

export default {
  actions,
  mutations,
  getters,
  state,
  namespaced: true
};
